import { Pipe, PipeTransform } from '@angular/core';

import moment from 'moment';

@Pipe({
  name: 'dateFormat'
})
export class DateFormatPipe implements PipeTransform {
  transform(value: Date | moment.Moment | string, ...args: any[]): string {
    if (value) {
      return moment(value).format(args[0]);
    }
  }
}
